import environment from "src/utils/environment";
import getIsDarkMode from "./getIsDarkMode";

export default function getNativeElementColor(
  element = "timePicker",
  color = "primary"
) {
  const { appName } = environment;
  const isDarkMode = getIsDarkMode();
  const theme = isDarkMode ? "dark" : "light";
  const selectors = {
    timePicker: `input[type="time"]::-webkit-calendar-picker-indicator`
  };
  const filters = {
    barkio: {
      light: {
        primary: {
          [selectors[element]]: {
            filter:
              "invert(77%) sepia(54%) saturate(6649%) hue-rotate(53deg) brightness(91%) contrast(93%)"
          }
        }
      },
      dark: {
        primary: {
          [selectors[element]]: {
            filter:
              "invert(36%) sepia(65%) saturate(4004%) hue-rotate(68deg) brightness(104%) contrast(101%)"
          }
        }
      }
    },
    bibino: {
      light: {
        primary: {
          [selectors[element]]: {
            filter:
              "invert(45%) sepia(69%) saturate(540%) hue-rotate(214deg) brightness(97%) contrast(99%)"
          }
        }
      },
      dark: {
        primary: {
          [selectors[element]]: {
            filter:
              "invert(35%) sepia(71%) saturate(2628%) hue-rotate(237deg) brightness(95%) contrast(99%)"
          }
        }
      }
    }
  };

  return filters[appName][theme][color];
}
